var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-md-12"},[_c('table-search-and-pagination',{attrs:{"table-data":_vm.customers},on:{"dataUpdated":function($event){_vm.queriedData = $event}}},[(_vm.customers.length)?_c('customers-table',{attrs:{"customers":_vm.queriedData}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }